module.exports = __webpack_public_path__ + "files/e127f91526868892f1e34e59ea091687.png";